import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { AtiraCheckBoxGroup } from "../../../../components/AtiraCheckBoxGroup";
import { Button } from "../../../../components/Button";
import { Flex } from "../../../../components/Flex";
import { Text } from "../../../../components/Text";
import { Modal } from "../../../../components/modal/Modal";
import { Conversation } from "../../../../model/integration/dto/meta/MetaConversation";
import { integrationSliceSelectors } from "../../../../redux/integration/integration.selector";
import { integrationActions } from "../../../../redux/integration/integration.slice";
import { permissionSliceSelectors } from "../../../../redux/permission/permission.selector";
import { useAppDispatch, useAppSelector } from "../../../../redux/store";
import { userSliceSelectors } from "../../../../redux/user/user.selector";
import { Spacing } from "../../../../theme/Spacing";
import { AtiraToast } from "../../../../utils/AtiraToast";

const Container = styled(Flex)`
  flex-direction: column;
  gap: ${Spacing.m};
  width: 100%;
`;

const StyledAtiraCheckBoxGroup = styled(AtiraCheckBoxGroup)`
  flex-direction: column;
  gap: ${Spacing.s};
`;

type Props = {
  open: boolean;
  onClose: () => void;
  chat: Conversation;
};

export const WAAssignModal: React.FC<Props> = ({ open, onClose, chat }) => {
  const [selected, setSelected] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const userId = useAppSelector(userSliceSelectors.selectLoggedInUserId)!;
  const members = useAppSelector(permissionSliceSelectors.selectMembers);
  const integration = useAppSelector(
    integrationSliceSelectors.selectWhatsAppMetaIntegration,
  );

  useEffect(() => {
    setSelected(chat?.assigneeIds || []);
  }, [chat?.assigneeIds, open]);

  const onSubmit = async () => {
    try {
      setLoading(true);

      await dispatch(
        integrationActions.assignWhatsappMetaConversation({
          userId,
          integrationId: integration!._id,
          conversationId: chat._id,
          assigneeIds: selected,
        }),
      ).unwrap();

      AtiraToast.success(t("integration.whatsapp.meta.assign.success"));
      onClose();
    } catch (e) {
      console.log(e);
      AtiraToast.apiError(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t("integration.whatsapp.meta.assign.title")}
    >
      <Container>
        {members.length ? (
          <StyledAtiraCheckBoxGroup
            options={members.map((m) => ({ label: m.name, value: m._id }))}
            value={selected}
            onChange={(values) => setSelected(values as string[])}
          />
        ) : (
          <Text color="darkerSub">
            {t("integration.whatsapp.meta.assign.noMembers")}
          </Text>
        )}

        <Button onClick={onSubmit} loading={loading} disabled={loading}>
          {t("common.save")}
        </Button>
      </Container>
    </Modal>
  );
};
